export const whatsAppMimeTypesForTemplate = new Set([
    // Images
    "image/jpeg",
    "image/gif",
    "image/png",

    // Video
    "video/mp4",

    // Documents
    "application/pdf",
]);

export const whatsAppMimeTypesForFreeForm = new Set([
    ...whatsAppMimeTypesForTemplate,

    // Audio
    "audio/ogg",
    "audio/amr",
    "audio/3gpp",
    "audio/mpeg",     // mp3
]);

export function isWhatsAppMediaForFreeForm(file) {
    return whatsAppMimeTypesForFreeForm.has(file.type);
}

export function isWhatsAppMediaForTemplate(file) {
    return whatsAppMimeTypesForTemplate.has(file.type);
}